import {Pipe, PipeTransform} from '@angular/core';
import {IAppointment} from '../../models/appointment';

@Pipe({
  name: 'getNotesByUser'
})
export class GetNotesByUserPipe implements PipeTransform {

  transform(value: IAppointment): number {
    let total = 0;
    value.users.forEach(user => {
      if (user.hasOwnProperty('noteCount')) {
        total += user.noteCount ? user.noteCount : 0;
      }
    });
    return total;
  }
}
